import { render, staticRenderFns } from "./InvoiceBot.vue?vue&type=template&id=0edd9e49&scoped=true&"
import script from "./InvoiceBot.vue?vue&type=script&lang=js&"
export * from "./InvoiceBot.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBot.vue?vue&type=style&index=0&id=0edd9e49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd9e49",
  null
  
)

export default component.exports